import * as React from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { PlaceOrderOperation } from "../../../../mappers/server/mappers/server/place-order-operation-mapper.js";
import { PLACE_ORDER } from "../../../../operations/mutations/operations/mutations/place-order.js";
const usePlaceOrder = () => {
  const [mutationCallback, { loading, error }] = useMutation(PLACE_ORDER);
  const placeOrder = React.useCallback(
    async (orderInputProp) => {
      return await mutationCallback({
        variables: {
          placeOrderInput: PlaceOrderOperation.placeOrderInput(orderInputProp)
        }
      }).then(({ data, errors }) => {
        if (data) {
          return PlaceOrderOperation.placeOrderOutput(data);
        }
        errors?.forEach((error2) => console.log("[error]:", error2.message));
        return { success: false, redirect: false };
      }).catch((error2) => {
        console.error("[error]:", error2);
        return { success: false, redirect: false };
      });
    },
    [mutationCallback]
  );
  return {
    isUpdating: loading,
    updateError: error,
    placeOrder
  };
};
export {
  usePlaceOrder
};
//# sourceMappingURL=use-place-order.js.map
